/* istanbul ignore file */

import Vue from "vue";
import ReadMore from "../components/read-more/ReadMore";
import StoreZoomer from "../components/zoomer/StoreZoomer";
import StoreSwiper from "../components/swiper/StoreSwiper";
import StoreStaticMap from "../components/static-map/StoreStaticMap_Google";
import StoreVendorIntroButton from "../components/vendor-intro/StoreVendorIntro_Button";
import StoreVendorIntroVideo from "../components/vendor-intro/StoreVendorIntro_Video";
import StoreProductGallery from "../components/product-gallery/StoreProductGallery";
import StoreVariantPicker from "../components/variant-picker/StoreVariantPicker";
import StoreVariantPrice from "../components/variant-price/StoreVariantPrice";
import StoreProductHiddenField from "../components/variant-picker/StoreProductHiddenField";
import StoreSubmitButton from "../components/variant-picker/StoreSubmitButton";
import StoreCashbackPrice from "../components/cashback-price/StoreCashbackPrice";
import StoreSavingsBadge from "../components/savings-badge/StoreSavingsBadge";
import OtherVendors from "../components/other-vendors/OtherVendors";
import WishlistButton from "../components/wishlist/WishlistButton";
import store from "../store";
import SocialSharing from "vue-social-sharing";
import { mapGetters } from "vuex";

const vueEl = "[data-vue-view='product-show']";

document.ready.then(() => {
  if (document.querySelector(vueEl)) {
    Vue.use(SocialSharing);

    new Vue({
      el: vueEl,
      store,
      name: "ProductShow",
      components: {
        "read-more": ReadMore,
        "store-zoomer": StoreZoomer,
        "store-swiper": StoreSwiper,
        "store-vendor-intro-button": StoreVendorIntroButton,
        "store-vendor-intro-video": StoreVendorIntroVideo,
        "google-map-static": StoreStaticMap,
        "store-product-gallery": StoreProductGallery,
        "store-variant-picker": StoreVariantPicker,
        "store-variant-price": StoreVariantPrice,
        "store-product-hidden-field": StoreProductHiddenField,
        "store-savings-badge": StoreSavingsBadge,
        "store-submit-button": StoreSubmitButton,
        "store-cashback-price": StoreCashbackPrice,
        "other-vendors": OtherVendors,
        "wishlist-button": WishlistButton,
      },
      computed: {
        ...mapGetters({ toggles: "getGlobalToggles" }),
      },
      mounted() {
        window._lytics_.attachEventListeners(this.$el);
      },
    });
  }
});
